import React, { FC, memo, useCallback, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import ReactPlayer from 'react-player'
import { SectionContainer } from 'containers/SectionContainer'
import { InnerContainer } from 'containers/InnerContainer'
import { TitleSection } from 'components/TitleSection'
import { ButtonMUI } from 'components/ButtonMUI'
import { TitleBottomSection } from 'components/TitleBottomSection'
import { NewResource } from './NewResource'


import styles from './styles.module.scss'

interface IProps {
}

const newsResourceLogo = [
  {
    name: 'newsCNBC',
    width: '83%',
    link: 'https://youtu.be/Gmam3grMCH4?si=Vchwzffz2l2W0Yw1'
  },
  {
    name: 'newsTed',
    width: '64%',
    link: 'https://youtu.be/odbqlASYv9E?si=BCZHo8L-L-YQr3qs'
  },
  {
    name: 'newsYahoo',
    width: '76%',
    link: 'https://finance.yahoo.com/news/somnium-space-sells-immortality-using-124100643.html'
  },
  {
    name: 'newsVentureBeat',
    width: '90%',
    link: 'https://venturebeat.com/'
  },
  {
    name: 'newsCzechcrunch',
    width: '95%',
    link: 'https://cc.cz/sejdeme-se-v-metaversu-v-ceskem-virtualnim-svete-somnium-space-se-toci-miliardy-a-investuji-do-nej-i-winklevossovi/'
  },
  {
    name: 'newsNpr',
    width: '64%',
    link: 'https://www.npr.org/2023/03/31/1167136624/how-we-could-live-forever-virtually '
  },
  {
    name: 'newsCoinTelegraph',
    width: '90%',
    link: 'https://cointelegraph.com/news/vr-world-somnium-space-sells-110-eth-of-virtual-land'
  },
  {
    name: 'newsForbes',
    width: '64%',
    link: 'https://www.forbes.com/sites/jackkelly/2022/02/12/somnium-space-is-an-immersive-out-of-this-world-metaverse-experience/?sh=4b157be7609c'
  },
  {
    name: 'newsUpload',
    width: '88%',
    link: 'https://www.uploadvr.com/somnium-vr1-lens-weight-improvements/'
  },
  {
    name: 'newsCNN',
    width: '50%',
    link: 'https://edition.cnn.com/videos/tv/2022/09/26/decoded-metaverse-show-spc-intl.cnn'
  },
  {
    name: 'newsViceTV',
    width: '86%',
    link: 'https://www.vice.com/en/article/pkp47y/metaverse-company-to-offer-immortality-through-live-forever-mode'
  }
]

const RecognizedMediaSection: FC<IProps> = props => {

  return (
    <SectionContainer>
      <InnerContainer style={{ height: '100%', alignItems: 'stretch', borderBottom: '1px solid white' }}>
        <div className={styles.recognizedMediaContainer}>
          <TitleSection title={'Recognized by the Media'}
                        subTitle={'Somnium Space in the News'}/>
          <div className={styles.middleBlock}>
            {newsResourceLogo.map(item => <NewResource link={item.link} name={item.name} key={item.name}
                                                       width={item.width}/>)}

          </div>
          <div className={styles.bottomBlock}>
            <TitleBottomSection
              title={'Media Resources'}
              subTitle={'Unlock the Press Kit: Explore Somnium Space\'s Logos and Pre-Written Articles'}/>
            <div className={styles.rightBox}>
              <ButtonMUI styleType={'white'}
                         onClick={() => {
                           window.open('https://somniumspace.com/files/Somnium_Space_Press_Kit_2023.zip', '_self', 'noopener,noreferrer')
                         }}
                         type="button"
                         sx={{
                           padding: '6px',
                           '&&': {
                             width: '225px',
                             height: '60px',
                             borderRadius: '30px'
                           }
                         }}>Download Press Kit</ButtonMUI>
            </div>
          </div>

        </div>
      </InnerContainer>
    </SectionContainer>
  )
}

export default memo(RecognizedMediaSection)
